<template>
  <v-container fluid class="pa-0">

    <Titulo></Titulo>

    <v-stepper v-model="e1" elevation="0" :class="Vstep">
      <div :class="Vflex">
        <NavBar v-if="loadMounted == true" :step="5" :typePlan="userData.typePlan"></NavBar>
        <v-stepper-header>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1" step="1"> Inicio
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Plan
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 4" step="4"> DPS
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" step="5"> Datos </v-stepper-step>
          </div>
        </v-stepper-header>
      </div>

      <v-stepper-items>
        <v-stepper-content step="5">
          <v-form ref="form" v-model="valid">
            <v-container style=" ">
              <div :class="formMainContainer">

                <v-col :class="vista">
                  <div v-if="screen > 800">
                    <br>
                    <br>
                    <br>
                    <br>
                  </div>
                  <br><br><br>

                  <h3 :class="labelIngresar" class="text-center">
                    {{ capitalizeName(userData.name) }} ya estamos en el último paso
                  </h3>

                  <h4 class="text-center labelSubingresar">
                     Ingresa tus datos
                  </h4>

                  <br>

                  <v-row :class="rowBody">
                    <div :class="formContainer" >
                      <p v-if="screen < 800" class="titleLabel">Datos personales</p>
                      <p :class="titleLabels" >Nombre</p>
                      <v-text-field class="labelsDatos" v-model="userData.name" :rules="nameRules" label="Nombre" required
                        @change="change()" maxlength="51" filled solo></v-text-field>

                      <br>
                      <p :class="titleLabels">Apellido </p>
                      <v-text-field class="labelsDatos" v-model="userData.surname" :rules="surnameRules" label="Apellido"
                        @change="change()" maxlength="51" required filled solo></v-text-field>

                      <br>
                      <p :class="titleLabels">Email </p>
                      <v-text-field class="labelsDatos" v-model="userData.email" :rules="emailRules" label="Email" required
                        @change="change()" maxlength="51" filled solo></v-text-field>

                      <br>
                      <p :class="titleLabels">Fecha de nacimiento </p>
                      <v-row v-if="screen < 800">

                        <v-col>
                          <v-select class="labelDatesMovil" style="max-width: 68px;width: 68px; height: 48px;" :rules="monthRules"
                            :items="months" v-model="userData.month" :loading="loadingMonths" v-on:change="getDays()"
                            item-text="name" label="Mes" return-object required filled solo></v-select>
                        </v-col>

                        <v-col>
                          <v-select class="labelDatesMovil" style="max-width: 68px;width: 68px; height: 48px;" :rules="dayRules"
                            :items="days" v-model="userData.day" :loading="loadingDays"
                            :disabled="loadingDays || userData.month === null" item-text="name" label="Día" return-object
                            required filled solo>
                          </v-select>
                        </v-col>

                        <v-col>
                          <v-select class="labelDatesMovil" style="max-width: 68px;width: 68px; height: 48px;" :rules="yearRules"
                            value="2022" :items="years" v-model="userData.year" item-text="name" label="Año" return-object
                            required filled solo @change="changeBisiesto()"></v-select>
                        </v-col>

                      </v-row>

                      <v-row v-else style="display: flex; justify-content: center; margin: auto;">

                          <v-select class="labelDatesdesktop" style="max-width: 35%; height: 48px; margin-right: 2px;" :rules="monthRules"
                            :items="months" v-model="userData.month" :loading="loadingMonths" v-on:change="getDays()"
                            item-text="name" label="Mes" return-object required filled solo></v-select>
                        
                          <v-select class="labelDatesdesktop" style="max-width: 32%; height: 48px; margin-right: 2px;" :rules="dayRules"
                            :items="days" v-model="userData.day" :loading="loadingDays"
                            :disabled="loadingDays || userData.month === null" item-text="name" label="Día" return-object
                            required filled solo>
                          </v-select>
                      
                          <v-select class="labelDatesdesktop" style="max-width: 32%; height: 48px;" :rules="yearRules"
                            value="2022" :items="years" v-model="userData.year" item-text="name" label="Año" return-object
                            required filled solo @change="changeBisiesto()"></v-select>
                        
                      </v-row>

                      <br>
                      <p :class="titleLabels">Teléfono </p>
                      <v-text-field class="labelsDatos" v-model="userData.phoneNumber" :rules="phoneRules" prefix="+569"
                        @change="change()" :counter="8" maxlength="8" label="Teléfono" required filled solo></v-text-field>

                      <br>
                      <p :class="titleLabels">RUT </p>
                      <v-text-field class="labelsDatos" v-model.lazy="newRut" :rules="rutRules(newRut)" @change="change()"
                        label="Ingresa tu RUT" required filled solo @input="changeRut"></v-text-field>

                      <br>
                    </div>

                    <!-- <br v-if="screen < 800"> -->

                    <div :class="formContainer">
                      <p v-if="screen < 800" class="titleLabel">Datos personales</p>
                      <p :class="titleLabels">Región </p>
                      <v-select class="labelsDatos" :items="regions" v-model="userData.region" :rules="regionRules"
                        @change="change()" :loading="loadingRegions" v-on:change="getCommunes()" item-text="name"
                        label="Selecciona tu región de residencia" required return-object filled solo></v-select>

                      <br>
                      <p :class="titleLabels">Comuna </p>
                      <v-select class="labelsDatos" :items="communes" v-model="userData.commune" :rules="communeRules"
                        @change="change()" :loading="loadingCommunes"
                        :disabled="loadingCommunes || userData.region === null" item-text="name"
                        label="Selecciona tu comuna de residencia" required return-object filled solo>
                      </v-select>

                      <br>
                      <p :class="titleLabels">Nombre de la calle o avenida </p>
                      <v-text-field class="labelsDatos" v-model="userData.address" :rules="addressRules" maxlength="51"
                        @change="change()" label="Ingresar nombre de calle" required filled solo></v-text-field>

                      <br>

                      <p :class="titleLabels">Número de calle </p>
                      <v-text-field class="labelsDatos-address" v-model="userData.addressNumber"
                      :rules="NumberRulesAddress" maxlength="51" :label="addressNumber" required filled solo
                      @change="change()"></v-text-field>

                      <br>
                      <p :class="titleLabels">Número de departamento </p>
                      <v-text-field :rules="NumberRulesAddress2" class="labelsDatos-address" v-model="userData.addressDepto" maxlength="51"
                      :label="addressDepto" required filled solo @change="change()"></v-text-field>
                
                      <br>
                      <p :class="titleLabels">Previsión de Salud </p>
                      <v-select class="labelsDatos" :items="isapreTypes"
                        v-model="userData.typeIsapre" label="Selecciona tu Sistema de Salud" :rules="typeIsapreRules" return-object required
                        filled solo @change="changeSalud()"></v-select>

                      <br>
                      <br>
                    </div>
                    <br><br><br><br>
                    
                  </v-row>

                  <!-- <v-text-field class="labelsDatos" v-model="userData.serialNumber" :rules="serialNumberRules"
                    @change="change()" maxlength="10" label="Ingresa el número de Documento / Serie" required filled
                    solo>
                  </v-text-field>

                  <br> -->
                  
                  <br><br>
                <div :class="buttonContainer"> 
                  <div class="button-container">
                    <div :class="summaryContainerContratante">
                      <div v-if="screen < 800" style="display: flex;color: white;padding-top: 2%;">
                        <div style="display: flex;height: 31px;width: 100%;">
                          <img :src="shieldIconMobile" alt="shieldIcon" class="iconMobile">
                          <div style="display: block;">
                            <p class="iconTitle">Tipo de plan:</p>
                            <p class="iconSubtitle">{{ userData.typePlan }}</p>
                          </div>
                        </div>
                        <div style="display: flex;height: 31px;width: 100%;">
                          <img :src="clockIconMobile" alt="clockIcon" class="iconMobile">
                          <div style="display: block;">
                            <p class="iconTitle">Activación:</p>
                            <p class="iconSubtitle">En 30 días continuos</p>
                          </div>
                        </div>
                        <div style="display: flex;height: 31px;width: 100%;">
                          <img :src="cashIconMobile" alt="cashIcon" class="iconMobile">
                          <div style="display: block;">
                            <p class="iconTitle">Prima mensual:</p>
                            <p class="iconSubtitle">{{ planData.plan.values[0].priceString }}</p>
                          </div>
                        </div>
                      </div>
                      <br><br>
                      <div v-if="screen < 800" style="width: 100%; display: flex;">
                        <v-btn  style="background-color: #4F74E3 !important; color: white; display: flex; justify-content: center;" @click="validate()" block>
                        Continuar
                      </v-btn>
                      </div>
                      
                    </div> 

                    <br><br><br>

                    <div v-if="screen > 800" style="position: fixed; bottom: 0; left: 0; width: 100%; z-index: 9999;">
                      <div class="cta-bar">
                        <div class="cta-item">
                          <div class="cta-content">
                            <img :src=ticketFooter alt="ticketFooter">
                            <div style="margin-left: 10px;">
                              <div class="cta-label">Tipo de plan:</div>
                              <div v-if="this.planData.plan.cantBenf.includes('familiar')" class="cta-value">Familiar</div>
                              <div v-else class="cta-value">Individual</div>
                            </div>
                          </div>
                        </div>

                        <div class="cta-item">
                          <div class="cta-content">
                            <img :src=watchFooter alt="watchFooter">
                            <div style="margin-left: 10px;">
                              <div class="cta-label">Activación:</div>
                              <div class="cta-value">En 30 días continuos</div>
                            </div>
                          </div>
                        </div>

                        <div class="cta-item">
                          <div class="cta-content">
                            <img :src=currencyFooter alt="currencyFooter">
                            <div style="margin-left: 10px;">
                              <div class="cta-label">Prima mensual:</div>
                              <div class="cta-value">{{ formatPrice(planData.plan.values[0].priceCLP) }} (UF {{ (planData.plan.values[0].price).toFixed(2) }})</div>
                            </div>
                          </div>
                        </div>

                        <div v-if="loadingNext == false" class="cta-item">
                          <v-btn :class="btnContinue" style="background-color: #4F74E3 !important;" @click="validate()" block>
                            Continuar
                          </v-btn>
                        </div>

                        <div v-if="loadingNext == true" class="text-center" style="margin-right:17%; margin-left: 5%;">
                            <v-progress-circular :size="20" color="white" indeterminate></v-progress-circular>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
                </v-col>

              </div>
            </v-container>
          </v-form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

  </v-container>
</template>

<script>

import CountryService from "@/services/country.service.js";
import Titulo from "../components/Titulo.vue";
import RutUtils from "@/utils/rut.utils.js";
import NavBar from "@/components/NavBar.vue";

import ShieldService from "../services/shield.service";
import dateService from "@/services/date.service.js";
import yearService from "@/services/year.service.js";

import clockIconMobile from "@/assets/images/clockIcon.svg";
import shieldIconMobile from "@/assets/images/shieldIcon.svg";
import cashIconMobile from "@/assets/images/cashIcon.svg";
import ticketFooter from "@/assets/images/ticketFooter.svg";
import watchFooter from "@/assets/images/watchFooter.svg";
import currencyFooter from "@/assets/images/currencyFooter.svg";

import swal from 'sweetalert';
const moment = require('moment');
import CryptoJS from 'crypto-js';

import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Step4",
  components: { Titulo, NavBar },
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    loadMounted: false,
    screen: window.screen.width,
    stepperColor: '#4F74E3',
    formatter: new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }),
    clockIconMobile,
    shieldIconMobile,
    cashIconMobile,
    ticketFooter,
    watchFooter,
    currencyFooter,
    loadingNext: false,
    stepId: null,
    TipoPlan: null,
    labelIngresar: null,
    e1: 5,
    Vstep: '',
    Vflex: '',
    valid: false,
    formContainer: null,
    btnContinue: null,
    stepperContainer: null,
    titleLabels: null,
    summaryContainerContratante: null,
    buttonContainer: null,
    formMainContainer: null,
    // isapreTypes: ["Banmédica", "Chuquicamata", "Colmena", "Consalud", "Cruz Blanca", "Cruz del Norte", "Nueva Masvida", "Fundación", "Fusat", "Río Blanco", "San Lorenzo Ltda.", "Vida Tres"],
    isapreTypes: ["Fonasa" ,"Banmédica", "Chuquicamata", "Colmena", "Consalud", "Cruz Blanca", "Nueva Masvida", "Fundación", "Fusat", "San Lorenzo Ltda.", "Vida Tres", "Santa María", "Más Salud", "Esencial"],
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      typeIsapre: null,
      region: null,
      commune: null,
      comuneCode: null,
      regionCode: null,
      address: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      stepId: null,
      old: null,
      dates: null,
      salud: null,
      questionOne: null,
      questionTwo: null,
      questionThree: null,
      typePlan: null,
      addressNumber: null,
      addressDepto: null,
      sonExist: false,
      arrayTypesBenef: [],
      oldAux: null,
      day: null,
      month: null,
      year: null,
    },
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'create',
    },
    planData: {
      planOutDesc: null,
      setDesc: false,
      valueDesc: 0,
      couponId: null,
      plan: null,
    },
    benefData: [
      {
        validRut: false,
        tipo: null,
        edad: null,
        name: '',
        surname: '',
        rut: '',
        days: ['Selecciona el mes'],
        months: null,
        years: null,
        date: null,
        newRut: '',
        panel: 0,
        year: null,
        month: null,
        day: null,
      }
    ],
    rutIsDuplicate: false,
    months: [],
    days: ["Selecciona el mes"],
    yars: [],
    month: null,
    day: null,
    yar: null,
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
    addressRules: [
      (v) => !!v || "Debes ingresar tu dirección",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres",
      (v) => /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/.test(v) || "Ingrese solo números y letras"
    ],
    typeIsapreRules: [(v) => !!v || "Debes ingresar tu Sistema de Salud",],
    regionRules: [(v) => !!v || "Debes ingresar tu región",],
    communeRules: [(v) => !!v || "Debes ingresar tu comuna",],
    serialNumberRules: [
      (v) => !!v || "El número de serie es requerido",
      (v) => (!!v && v.length <= 9) || "Debe ingresar máximo 9 carácteres",
      (v) => /^[0-9]*$/.test(v) || "Ingrese solo números"
    ],
    NumberRulesAddress: [
      (v) => !!v || "N° de calle requerido",
      (v) => (!!v && v.length <= 9) || "Debe ingresar máximo 9 carácteres",
      (v) => /^[0-9]+$/.test(v) || "Ingrese solo números"
    ],
    NumberRulesAddressNumber: [
      (v) => /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ]+$/.test(v) || "Ingrese solo números y letras"
    ],
    NumberRulesAddress2: [
      (v) => !v || /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ]+$/.test(v) || "Ingrese solo números y letras"
    ],
    emailRules: [
      (v) => !!v || "El correo electrónico es requerido",
      (v) => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || "Ingrese un correo válido",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
    ],
    phoneRules: [
      (v) => !!v || "Número telefónico requerido",
      (v) => /^[0-9]*$/.test(v) || "Ingrese solo números",
      (v) => (!!v && v.length == 8) || "Ingrese un número válido",
    ],
    nameRules: [
      (v) => !!v || "El nombre es requerido",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres",
    ],
    surnameRules: [
      (v) => !!v || "El apellido es requerido",
      (v) => /^[a-zA-ZáéíóúüÜñÑ\s]+$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
    ],
    monthRules: [
      (v) => !!v || "El mes es requerido",
    ],
    dayRules: [
      (v) => !!v || "El día es requerido",
    ],
    yearRules: [
      (v) => !!v || "El año es requerido",
    ],
    regions: [],
    communes: [],
    newRut: "",

  }),
  async mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.body.setAttribute('data-sku', 'ONC-004-DTC');

    this.getRegions();
    this.getMonths();
    this.getYears();

    const userDataAux = sessionStorage.getItem('userData');
    const benefDataAux = sessionStorage.getItem('benefData');
    const servicesDataAux = sessionStorage.getItem('servicesData');
    const planDataAux = sessionStorage.getItem('planData');

    const query = this.$route.query;

    if (query.stepID) {

      const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

      this.userData = abandoned.userData;
      this.servicesData.stepId = abandoned._id;
      this.servicesData.type = 'update';
      this.planData = abandoned.planData;

      if (abandoned.benefData) {
        this.benefData = abandoned.benefData;
      }

      const userDataLocal = JSON.stringify(this.userData);
      const servicesDataLocal = JSON.stringify(this.servicesData);
      const planDataLocal = JSON.stringify(this.planData);
      const benefDataLocal = JSON.stringify(this.benefData);

      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
      const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
      const encryptedBenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();

      sessionStorage.setItem('userData', encryptedUserDataLocal);
      sessionStorage.setItem('servicesData', encryptedServicesDataLocal);
      sessionStorage.setItem('planData', encryptedPlanDataLocal);
      sessionStorage.setItem('benefData', encryptedBenefDataLocal)

      this.getCommunes();

      if (this.userData.rut) {
        this.newRut = this.userData.rut;
        this.changeRut(this.userData.rut);
      }

      if (this.userData.dates) {
        this.getDaysMounted();
      }

    } else {

      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);

      this.getCommunes();

      if (this.userData.dates) {
        this.getDaysMounted();
      }
      // console.log("userData: ", this.userData);

      if (benefDataAux) {
        const bytesBenefData = CryptoJS.AES.decrypt(benefDataAux, this.secretKey);
        const decryptedDataPet = bytesBenefData.toString(CryptoJS.enc.Utf8);
        this.benefData = JSON.parse(decryptedDataPet);
        // console.log("benefData: ", this.benefData);
      }

      if (this.userData.rut) {
        this.newRut = this.userData.rut;
        this.changeRut(this.userData.rut);
      }

      const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
      const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
      this.servicesData = JSON.parse(decryptedServicesData);
      // console.log("servicesData: ", this.servicesData);

      const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
      const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
      this.planData = JSON.parse(decryptedDataPlan);
      // console.log("planData: ", this.planData);
    }

    if (this.screen > 800) {
      this.vista = 'vista2';
      this.TipoPlan = 'PlanEscritorio';
      this.addressNumber = 'Ingresa tu número de calle';
      this.addressDepto = 'Ingresa tu número de depto';
      this.labelIngresar = 'labelIngresar';
      this.formContainer = 'formContainer';
      this.btnContinue = 'btnContinue';
      this.stepperContainer = 'stepperContainer';
      this.titleLabels = 'titleLabels';
      this.summaryContainerContratante = 'summaryContainerContratante';
      this.buttonContainer = 'buttonContainer';
      this.formMainContainer = 'formMainContainer';
      this.Vstep = 'VstepDesktop';
      this.Vflex = 'VflexDesktop';
      this.rowBody = 'rowBody'
    } else {
      this.vista = 'vista';
      this.TipoPlan = 'PlanMovil';
      this.addressNumber = 'Número de calle';
      this.addressDepto = 'Número de depto';
      this.labelIngresar = 'labelIngresar2';
      this.formContainer = 'formContainer2';
      this.btnContinue = 'btnContinue2';
      this.stepperContainer = 'stepperContainer2';
      this.titleLabels = 'titleLabels2';
      this.summaryContainerContratante = 'summaryContainerContratante2';
      this.buttonContainer = 'buttonContainer2';
      this.formMainContainer = 'formMainContainer2';
      this.Vflex = 'VflexMobile';
      this.rowBody = 'rowBody2'
    }

    this.loadMounted = true;
  },
  methods: {
    capitalizeName(name) {
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    formatPrice(number) {
      return this.formatter.format(number);
    },
    async changeBisiesto() {
      if (this.userData.month && this.userData.year && this.days && this.userData.month.name == 'Febrero' && !this.isBisiesto(this.userData.year.id) && this.days.length == 29) {
        this.userData.day = null;
        this.days = await dateService.getDays(
          this.userData.month.name, false
        );
      } else if (this.userData.month && this.userData.year && this.days && this.userData.month.name == 'Febrero' && this.isBisiesto(this.userData.year.id) && this.days.length == 28) {
        this.days = await dateService.getDays(
          this.userData.month.name, true
        );
      } else {
        this.days = await dateService.getDays(
          this.userData.month.name, null
        );
      }
    },
    isBisiesto(anio) {
      return (anio % 4 === 0 && anio % 100 !== 0) || (anio % 400 === 0);
    },
    async getMonths() {
      this.loadingMonths = true;
      this.months = await dateService.getMonths();
      this.loadingMonths = false;
    },
    async getDays() {
      if (this.userData.month) {
        this.loadingDays = true;
        this.userData.day = null;
        this.changeBisiesto();
        this.loadingDays = false;
      }
    },
    async getDaysMounted() {
      if (this.userData.month) {
        this.loadingDays = true;
        this.changeBisiesto();
        this.loadingDays = false;
      }
    },
    async getYears() {
      this.loadingYears = true;
      this.years = await yearService.getYears();
      this.loadingYears = false;
    },
    rutRules(v) {
      return [
        !!v || "El RUT es requerido",
        (v) => (v && v.length >= 11 && v.length <= 12) || "Rut no válido",
        RutUtils.validateRut(v) || "Rut no válido",
        RutUtils.getCondition(v, this.rutIsDuplicate) || "RUT coincide con beneficiario"
      ];
    },
    async getRegions() {
      this.loadingRegions = true;
      this.regions = await CountryService.getRegions();
      this.loadingRegions = false;
    },
    async getCommunes() {
      if (this.userData.region) {
        this.loadingCommunes = true;
        // this.userData.commune = null;
        this.communes = await CountryService.getCommunes(
          this.userData.region.name
        );
        this.loadingCommunes = false;
      }
    },
    changeRut(rut) {
      if (this.userData.typePlan == 'Familiar') {

        const cleanRut = (rut) => rut ? rut.replace(/[.-]/g, '').toLowerCase() : '';

        const rutExists = this.benefData.some(benef => cleanRut(benef.rut) === cleanRut(rut));

        if (rutExists) {
          this.rutIsDuplicate = true;
          swal({
            title: "¡Atención!",
            text: "¡Tu RUT no puede coincidir con el de algún beneficiario!",
            icon: "info",
            button: "De acuerdo",
          });
        } else {
          this.rutIsDuplicate = false;
        }
      } else {
        this.rutIsDuplicate = false;
      }
      this.userData.rut = RutUtils.cleanRut(rut);
      this.newRut = RutUtils.formatRut(rut);
      this.userData.rut = this.newRut;
    },
    changeSalud() {

       if (this.userData.typeIsapre == 'Fonasa') {
        this.userData.salud = 'Fonasa'
       } else {
         this.userData.salud = 'Isapre'
       }
    },
    async validate() {
      if (this.$refs.form.validate() && this.rutIsDuplicate === false) {

        this.loadingNext = true
        
        try {

          const fechaActual = new moment(new Date());
          let newDate = this.userData.year.id + "-" + this.userData.month.number + "-" + this.userData.day.id
          let dateNacimiento = moment(new Date(newDate));
          let timesDiff = fechaActual.diff(dateNacimiento, 'years');

          if (timesDiff < 18) {
            swal({
              title: "¡Atención!",
              text: "¡Para contratar este seguro, usted debe ser mayor de edad!",
              icon: "info",
              button: "De acuerdo",
            });
            this.loadingNext = false
          }  else if(timesDiff > 80) {
            swal({
              title: "¡Atención!",
              text: "¡La fecha de nacimiento no puede ser mayor a 80 años!",
              icon: "info",
              button: "De acuerdo",
            });
            this.loadingNext = false
          } else if (timesDiff != this.userData.old.name) {
            swal({
              title: "¡Atención!",
              text: "¡La fecha de nacimiento no concuerda con su edad!",
              icon: "info",
              button: "De acuerdo",
            });
            this.loadingNext = false
          } else {
            //Add Black List Rut Validation
            // reCaptcha v3 token
            await this.$recaptchaLoaded();
            const tokenList = await this.$recaptcha('rutBlacklist');
            const consultBlackList = await ShieldService.consultRutBlacklist(this.newRut, tokenList);
            if (consultBlackList.status === "error") {
              swal({
                title: "Error",
                // text: consultBlackList.message,
                text: "",
                icon: "error",
                button: "Cerrar",
              });
              return;
            }

            if (consultBlackList.isBlacklisted) {
              swal({
                title: "Error",
                text: "",
                icon: "error",
                buttons: false,
                timer: 5000,
              });

              setTimeout(() => {
                this.$router.push({ path: "/og/" });
              }, 5000);
              return;
            }

            //Add only one insurance logic
            const checkHaveInsurance = await ShieldService.checkHaveInsurance(this.newRut);
            // console.log('checkHaveInsurance:',checkHaveInsurance);
            if (checkHaveInsurance.status == 'ok'){
              if (checkHaveInsurance.haveInsurance){
                swal({
                    title: "Lo sentimos, ya tienes un seguro contratado",
                    text: "Te invitamos a cotizar otros seguros",
                    icon: "error",
                    buttons: {
                      confirm: {
                        text: "Ver otros productos",
                        value: true,
                        visible: true,
                        className: "swal-button-confirm-custom"
                      },
                      cancel: {
                        text: "Cerrar",
                        visible: true,
                      }
                    },
                    dangerMode: true
                  }).then((value) => {
                    if (value) {
                      window.location.href = "https://southbridgeseguros.cl/";
                    } else {
                      this.$router.push({ path: "/og/" });
                    }
                  });
                  return;
              }
            } else {
              swal({
                title: "Error",
                text: "No se pudo comprobar si tienes un seguro contratado. Por favor, intenta nuevamente.",
                icon: "error",
                button: "Cerrar",
                dangerMode: true
              });
              return;
            }
            
            let setlet = false;

            this.userData.dates = newDate;

            if (this.userData.typePlan == 'Familiar') {
              this.userData.sonExist = this.benefData.some(benef => benef.tipo === "Hijo(a)");
              this.userData.arrayTypesBenef = this.benefData.map(item => item.tipo);
            } else {
              this.userData.sonExist = false;
              this.userData.arrayTypesBenef = [];
            }

            this.change();
            // reCaptcha v3 token
            await this.$recaptchaLoaded();
            const tokenStep = await this.$recaptcha('captchaToken');

            const userDataLocal = JSON.stringify(this.userData);
            const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
            sessionStorage.setItem('userData', encryptedUserDataLocal);

            await ShieldService.newCreateStep(this.userData, null, null, this.servicesData, 'Resumen', tokenStep);

            if (this.activeCampaingUse == 'TRUE') {

              const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

              if (activeCampaingRes.data.data.meta.total != '0') {
                this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;
                setlet = true;
              } else {
                this.servicesData.contactID = null;
              }

              const shieldRes = await ShieldService.updateContactActiveCampain(this.userData, this.planData, this.servicesData, 'datos contratante');

              this.servicesData.contactID = setlet ? shieldRes.data.data.contact.id : shieldRes.data.data.contacts[0].id;

              const servicesDataLocal = JSON.stringify(this.servicesData);
              const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
              sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

            }

            this.$router.push({ path: '/og/resumen' })
          }

        } catch (error) {
          this.$router.push({ path: '/og/error' })
        }

      }
    },
    back() {
      this.$router.push({ path: '/og/dps' })
    },
    async change() {
      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      if (this.userData.year && this.userData.month && this.userData.day) {
        const fechaActual = new Date();
        let newDate = this.userData.year.id + "-" + this.userData.month.number + "-" + this.userData.day.id
        let diff = fechaActual.getFullYear() - this.userData.year.id
        if (diff > 18) {
          this.userData.dates = newDate;
        }
      }

      try {
        await ShieldService.newCreateStep(this.userData, null, null, this.servicesData, 'Datos personales' , tokenStep);
      } catch (error) {
        console.log("Cart Fail");
      }
    }
  },
};
</script>

<style lang="scss">

.VstepDesktop {
  margin-top: -0.3%
}

.VflexDesktop {
    background-color: rgb(247, 247, 247);
    display: flex;
    margin: auto;
    height: 50px;
}

.VflexMobile {
    background-color: rgb(247, 247, 247);
    display: flex;
    margin: auto;
    height: 30px;
    margin-top: -2.3%;
    margin-bottom: 2.3%
}

.buttonContainer2{
  margin-bottom: -14%;
}
.iconTitle{
  color: #FFFFFF;
  font-weight: 700;
  font-size: 12px;
  text-align: left;
  line-height: 15px !important;
  margin-left: 6%;
  margin-bottom: 6% !important;
}
.iconSubtitle{
  color: #FFFFFF;
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  line-height: 15px !important;
  margin-left: 6%;
}
.iconMobile{
  display: flex;
  justify-content: center;
  width: 24px !important;
  margin: auto;
  margin-top: -1%;
}
.summaryContainerContratante2{
  background-color: #2D387C;
  position: absolute;
  bottom: 0;
  z-index: 9999;
  width: 100%;
  margin-left: -6%;
  margin-right: -6%;
  height: auto;
  padding-top: 3%;
  padding-bottom: 3%;
  margin-bottom: 1% !important;
}
.titleLabels{
  display: flex; 
  text-align: flex-start; 
  margin-bottom: 3%; 
  font-weight: 700;
  color: #2D387C !important;
}
.titleLabels2{
  display: flex; 
  justify-content: left !important; 
  // margin-bottom: 3%; 
  font-weight: 600;
  font-size: 12px;
  color: #525252 !important;
  margin-bottom: 2% !important;
}
.stepperContainer{
  margin-top: -9% !important;
}
.stepperContainer2{
  margin-top: -20% !important;
}
.btnContinue{
  background-color: #4F74E3 !important; 
  color: white !important; 
  border-radius: 12px; 
  width: 300px;
}
.btnContinue2{
  background-color: #4F74E3 !important; 
  color: white !important; 
  border-radius: 24px; 
  width: 200px;
  margin-top: -2%;
}
.formContainer{
  margin-right: 60px; 
  width: 45%; 
  border-radius: 20px;  
  border: rgba(226, 226, 226, 1) 1px solid; 
  padding: 30px;
}
.formContainer2{
  // margin-right: 60px; 
  border-radius: 20px;  
  width: 110% !important;
  border: rgba(226, 226, 226, 1) 1px solid; 
  padding: 30px;
  margin-bottom: 10%;
}
.swal-button-confirm-custom {
  background-color: #2d387c !important;
  color: white !important;
  border: none !important;
  margin-bottom: 2%;
}
.swal-button-confirm-custom:focus {
  outline: none !important;
  box-shadow: none !important;
}
.swal-button-container {
  display: flex !important;
  justify-content: center !important;

}

.formMainContainer{
  max-width: 3000px !important;
}
.formMainContainer2{
  // max-width: 3000px !important;
  width: 107%;
  margin-left: -3%;
}

.labelIngresar {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}
.labelIngresar2 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
  width: 118%;
  margin-left: -9%;
}

.labelSubingresar {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  padding: 2%;
}

.labelsDatos {
  box-sizing: border-box;
  height: 57px;
  margin: auto;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
  width: 100%;
}

.vista {
  max-width: 1000px;
}

.vista2 {
  min-width: 670px;
}

.step-date {
  align-items: center;
  display: flex;
  margin-left: 0rem;
}

.number-address {
  display: flex;
  gap: 10px;
}

.labelsDatos-address {
  box-sizing: border-box;
  height: 57px;
  margin: auto;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.cta-bar {
  display: flex;
  align-items: center;
  gap: 16px;    
  padding: 12px 16px;
  background: #2a3a86;
  color: #fff;
  border-radius: 6px;
}

.cta-item {
  flex: 1 1 0;
  min-width: 0;        
  display: flex;
  align-items: center;
}

.cta-content {
  display: flex;
  align-items: center;
}

.cta-label {
  font-size: 12px;
  line-height: 1;
  opacity: 0.85;
}

.cta-value {
  font-size: 12px;
}

.rowBody {
  display: flex; 
  justify-content: center; 
  flex-wrap: nowrap;
}

.rowBody {
  display: flex; 
  justify-content: center; 
}

html body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap main.v-main div.v-main__wrap div.container div.v-stepper.v-sheet.theme--light.elevation-0 div.v-stepper__items div.v-stepper__content div.v-stepper__wrapper form.v-form div.container div.form-container div.col.vista2 div.v-input.labelsDatos.v-input--is-disabled.theme--light.v-text-field.v-text-field--single-line.v-text-field--solo.v-text-field--filled.v-text-field--is-booted.v-text-field--enclosed.v-select div.v-input__control div.v-text-field__details div.v-messages.theme--light div.v-messages__wrapper div.v-messages__message {
  color: red;
}

html body div.swal-overlay.swal-overlay--show-modal div.swal-modal div.swal-text {
  text-align: center;
}
</style>